// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__5a745","label":"Completed_label__iLx-q"};